/*
 * ////////////////////////////////////////////////////////////////////////////////
 * //
 * // This software system consists of computer software and documentation.
 * // It contains trade secrets and confidential information which are proprietary
 * // to Everi Games Inc.  Its use or disclosure in whole or in part without
 * // the express written permission of Everi Games Inc. is prohibited.
 * //
 * // This software system is also an unpublished work protected under the copyright
 * // laws of the United States of America.
 * //
 * // Copyright © 2018 Everi Games Inc.  All Rights Reserved
 * //
 * ////////////////////////////////////////////////////////////////////////////////
 */

/** @hidden */
// tslint:disable-next-line:typedef
const property = cc._decorator.property;

@cc._decorator.ccclass
export default class AssetScaler extends cc.Component
{
    public static readonly ClientConfigProperty: string = 'clientConfig';

    @property
    protected isChild: boolean = false;

    private _hasResized: boolean = false;

    /** @hidden */
    public onLoad(): void
    {
        this.Resize();
    }

    public Resize(): void
    {
        if (this._hasResized) { return; }

        let scalar: number = 1;

        if (cc.sys.isBrowser)
        {
            const clientConfig: { scalar?: number } = window[AssetScaler.ClientConfigProperty];
            if (clientConfig)
            {
                scalar = clientConfig.scalar || scalar;
            }
        }

        const parent: cc.Node = this.node.parent;
        if (parent)
        {
            if (parent.getComponent(AssetScaler)) { this.isChild = true; }
            if (this.isChild && parent.getComponent(cc.Layout)) { this.isChild = false; }
        }

        const sprite: cc.Sprite = this.getComponent(cc.Sprite);
        if (sprite)
        {
            this.node.width *= scalar;
            this.node.height *= scalar;

            this.node.scaleX *= this.isChild ? scalar : 1 / scalar;
            this.node.scaleY *= this.isChild ? scalar : 1 / scalar;
        }

        const label: cc.Label = this.getComponent(cc.Label);
        if (label)
        {
            label.fontSize *= this.isChild ? 1 : 1 / scalar;
            label.lineHeight *= this.isChild ? 1 : scalar;
        }

        const layout: cc.Layout = this.getComponent(cc.Layout);
        if (layout)
        {
            layout.paddingBottom *= scalar;
            layout.paddingLeft *= scalar;
            layout.paddingRight *= scalar;
            layout.paddingTop *= scalar;
            layout.spacingX *= scalar;
            layout.spacingY *= scalar;
        }

        this._hasResized = true;
    }
}
